import { Steps as AntSteps } from 'antd';
import styled from 'styled-components';

import { StyleConstantsEnum } from '@style/style.constants';

export const Wrapper = styled.div`
  padding-top: 24px;
`;

export const Steps = styled(AntSteps)`
  & .ant-steps-item-content {
    min-height: 72px !important;
  }

  & .ant-steps-item-title {
    font-family: ${StyleConstantsEnum.TitleFontFamily};
    font-size: 16px;
  }

  & .ant-steps-item-description {
    font-size: 12px;
  }

  & .ant-steps-item-icon .ant-steps-icon {
    top: -1px;
    font-size: 14px;

    & svg {
      fill: ${(props) => props.theme.Steps.colorText};
      width: 12px;
      height: 12px;
    }
  }

  & .ant-steps-item-finish {
    & .ant-steps-item-tail:after {
      background-color: ${(props) => props.theme.Steps.controlItemBgActive} !important;
    }

    & .ant-steps-item-title {
      color: ${(props) => props.theme.Steps.colorTextDescription} !important;
    }
  }
`;

export const ButtonWrapper = styled.div`
  padding-top: 48px;
`;
